"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uiIcons = require("@blueprism/ui-icons");

var _Row = _interopRequireDefault(require("../../layout/Row"));

var _BaseInput = _interopRequireDefault(require("../BaseInput"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var HiddenCheckbox = (0, _styledComponents["default"])(_BaseInput["default"]).withConfig({
  displayName: "TableCheckBox__HiddenCheckbox",
  componentId: "sc-1urvk9n-0"
})(function (props) {
  return (0, _styledComponents.css)(["position:absolute;height:1px;width:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;:focus + ", "{background:", ";> ", "{background:", ";border:0.125rem solid ", ";opacity:1;}}"], StyledCheckbox, props.theme.color.focus, CheckBoxControl, props.theme.color.focus, props.theme.color.action);
});

var StyledCheckbox = _styledComponents["default"].div.withConfig({
  displayName: "TableCheckBox__StyledCheckbox",
  componentId: "sc-1urvk9n-1"
})(["display:inline-block;position:relative;width:2.5rem;height:2.5rem;padding:0.125rem;border-radius:10% 10% 30% 10%;"]);

var CheckBoxControl = _styledComponents["default"].div.withConfig({
  displayName: "TableCheckBox__CheckBoxControl",
  componentId: "sc-1urvk9n-2"
})(function (props) {
  return (0, _styledComponents.css)(["width:2.25rem;height:2.25rem;padding:0.25rem;border-radius:inherit;border:0.125rem solid ", ";background:", ";", ";"], props.disabled ? props.theme.color.structure : props.checked ? props.theme.color.paper : props.theme.color.action, props.disabled ? props.theme.color.paper : props.checked ? props.theme.color.action : props.theme.color.paper, !props.checked && (0, _styledComponents.css)(["opacity:0.45;"]));
});

var HitBox = _styledComponents["default"].div.withConfig({
  displayName: "TableCheckBox__HitBox",
  componentId: "sc-1urvk9n-3"
})(function (props) {
  return (0, _styledComponents.css)(["display:inline-flex;align-items:center;justify-content:center;width:1.5rem;height:1.5rem;padding:0;border-radius:10% 10% 30% 10%;background:", ";box-shadow:0 0 0 0.125rem transparent;svg{width:80%;height:80%;transform:scale(0);transition:transform 200ms cubic-bezier(0.2,1,0.45,1.7);path{fill:", ";}}", ""], props.theme.color.paper, props.theme.color.paper, props.checked && (0, _styledComponents.css)(["background:", ";", " svg{transform:scale(1);}"], props.disabled ? props.theme.color.structure : props.theme.color.action, props.disabled && (0, _styledComponents.css)(["box-shadow:0 0 0 0.125rem ", ";"], props.theme.color.paper)));
});

var CheckboxContainer = _styledComponents["default"].div.withConfig({
  displayName: "TableCheckBox__CheckboxContainer",
  componentId: "sc-1urvk9n-4"
})(["position:relative;display:inline-block;height:2.5rem;vertical-align:middle;height:2.5rem;"]);

var WrappingLabel = (0, _styledComponents["default"])(_Row["default"]).withConfig({
  displayName: "TableCheckBox__WrappingLabel",
  componentId: "sc-1urvk9n-5"
})(function (props) {
  return (0, _styledComponents.css)(["", " ", ":hover{", "{box-shadow:0 0 0 0.125rem ", ";transform:scale(1);}", "{background:", ";opacity:1;}}"], props.disabled ? (0, _styledComponents.css)(["pointer-events:none;"]) : (0, _styledComponents.css)(["cursor:pointer;"]), props.justify === 'between' && (0, _styledComponents.css)(["span{border-bottom:1px solid ", ";}"], props.theme.color.structure), HitBox, props.theme.color.hover, CheckBoxControl, props.theme.color.paper);
});
/**
 *
 * #### Styled checkbox type input form control

TableCheckBox is a styled and lite version of the standard CheckBox component designed to only be used within a Table component.

 ### Importing
 `import TableCheckBox from '@blueprism/ui-core/components/TableCheckBox';`
 */

var _ref2 = /*#__PURE__*/_react["default"].createElement(_uiIcons.Tick, null);

var TableCheckBox = function TableCheckBox(_ref) {
  var id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
      rest = _objectWithoutProperties(_ref, ["id", "name", "value", "checked", "disabled", "onChange", "onFocus", "onBlur"]);

  return /*#__PURE__*/_react["default"].createElement(WrappingLabel, {
    element: "label",
    gap: "small",
    align: "center",
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(CheckboxContainer, null, /*#__PURE__*/_react["default"].createElement(HiddenCheckbox, _extends({
    type: "checkbox",
    id: id,
    name: name,
    value: value,
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur
  }, rest)), /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
    checked: checked,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(CheckBoxControl, {
    checked: checked,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(HitBox, {
    checked: checked,
    disabled: disabled
  }, _ref2)))));
};

var _default = TableCheckBox;
exports["default"] = _default;